export const SGB_ORDER_DETAILS = "SGB_ORDER_DETAILS";
export const SGB_ORDER_ERROR = "SGB_ORDER_ERROR";
export const SGB_ORDER_HIDE_ERROR = "SGB_ORDER_HIDE_ERROR";
export const SGB_ORDER_START_LOADER = "SGB_ORDER_START_LOADER";
export const SGB_ORDER_STOP_LOADER = "SGB_ORDER_STOP_LOADER";
